export default "__VITE_ASSET__BBGKNB____"